export enum UserRfeStatus {
	Refused		= 0,
	Accepted	= 1,
	Canceled	= 2,
	None		= 3
}
